import { render } from "./Configurator2.vue?vue&type=template&id=4ffd9a9a&scoped=true"
import script from "./Configurator2.vue?vue&type=script&lang=js"
export * from "./Configurator2.vue?vue&type=script&lang=js"

import "./Configurator2.vue?vue&type=style&index=0&id=4ffd9a9a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffd9a9a"]])

export default __exports__